import {AvalancheReelsInitState} from '@fantasmagames/slot/src/modules/reels/avalanche/states/AvalancheReelsInitState';
import {RecodeLogic} from '@fantasmagames/slot/src/logic/integration/RecodeLogic';

export class GameAvalancheReelsInitState extends AvalancheReelsInitState {

	protected onInitResponse(): void {
		const logic: RecodeLogic = (this.module.logic as RecodeLogic);
		if (!logic.hasRestore) {
			this.view.createReelSet(logic.getRecodeSpinResults().reels);
		}

		super.onInitResponse();
	}
}



// WEBPACK FOOTER //
// ./src/avalanche/states/GameAvalancheReelsInitState.ts